// service/crm/hooks/useUpdateContactImportValueMappingMutation.ts

import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  contactImportApi,
  contactImportQueryKeys,
} from "service/crm/api/contactImport";
import {
  ContactImportRecord,
  ContactImportValueMappingRequest,
} from "types/crm/contactImport";

interface ValueMappingVariables extends ContactImportValueMappingRequest {
  importUuid: string;
}

/**
 * Saves the value mappings for one screen of the Dropdowns step.
 *
 * The saved import replaces what is cached, since each save resets the job and
 * the screens after this one read that state back.
 */
export const useUpdateContactImportValueMappingMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ContactImportRecord, unknown, ValueMappingVariables>({
    mutationFn: ({ importUuid, type, valueMapping }) =>
      contactImportApi.updateValueMapping(importUuid, { type, valueMapping }),
    onSuccess: (record) => {
      // Matches on the prefix, so whichever page of this import is cached is
      // the one that gets the saved state.
      queryClient.setQueriesData(
        { queryKey: contactImportQueryKeys.detail(record.uuid) },
        record
      );
    },
  });
};
